import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router-dom'

import { Loading } from '@/components/atoms/Loading'
import { Main } from '@/components/templates/main'
import { Error } from './components/Error'
import { Header } from './components/Header'
import { PostsGrid } from './components/PostsGrid'
import { ProfileHeader } from './components/ProfileHeader'

import { usePublicUserProfile } from './hooks/usePublicUserProfile'

export const PublicUserProfile: FC<RouteComponentProps> = ({
  match,
}: RouteComponentProps<{ userId: string }>) => {
  const { t } = useTranslation('common')

  const {
    params: { userId },
  } = match

  const { userInfo, wallet, isLoading, isError } = usePublicUserProfile({
    userId,
  })

  if (isError) return <Error />

  return (
    <Main
      header={<Header userId={userId} />}
      headTitle={t('common.head.title.profile')}
    >
      {!isLoading ? (
        <>
          <ProfileHeader userInfo={userInfo} wallet={wallet} />
          <PostsGrid username={userId} posts={userInfo?.posts} />
        </>
      ) : (
        <Loading />
      )}
    </Main>
  )
}
